const rotateShadowImages = {
    left_thin: 'https://s3.ap-south-1.amazonaws.com/cdn.stunnr.co/assets/shadows/ellipse/left_thin.svg',
    left_fat: 'https://s3.ap-south-1.amazonaws.com/cdn.stunnr.co/assets/shadows/ellipse/left_fat.svg',
    right_thin: 'https://s3.ap-south-1.amazonaws.com/cdn.stunnr.co/assets/shadows/ellipse/right_thin.svg',
    right_fat: 'https://s3.ap-south-1.amazonaws.com/cdn.stunnr.co/assets/shadows/ellipse/right_fat.svg',
}


export default rotateShadowImages;